import { render, staticRenderFns } from "./AnalisesDetails.vue?vue&type=template&id=d05cf50e"
import script from "./AnalisesDetails.vue?vue&type=script&lang=js"
export * from "./AnalisesDetails.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports